<div fxLayout="row" fxLayoutAlign="space-around start" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="40px" fxLayoutGap.sm="30px" fxLayoutAlign.sm="center center" style="margin-top: 10px;">
            <app-air-side-bar></app-air-side-bar>
        <div fxFlex class="genericContent p-3 p-sm-5 p-md-5 p-lg-5 p-xl-5 p-xxl-5 border-shadow sabadell-Container"  style="display: inline-block; word-wrap: break-word;" >
            <router-outlet name="about_airRouter"></router-outlet>
        </div>
</div>
<br>

